import { useEffect, useMemo, useRef, useState } from "react";
import Loader from "../../elements/Loader";
import Formsy from "formsy-react";
import FormsyInputField from "../elements/FormsyInputField";
import { Accordion, AccordionItem, AccordionItemHeading, AccordionItemButton, AccordionItemPanel } from "react-accessible-accordion";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import { useApolloClient } from "@apollo/client";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { getUCRFFormFillStatus, getUCRFLeadDetail, getLeadRemarkUCRF } from "../../../store/action/allAction";
import { executeGraphQLMutation, executeGraphQLQuery } from "../../../services/refinance/executeGraphQLQuery";
import { SAVE_REFINANCE_CALCULATION } from "../../../services/refinance/refinance-computation.gql";
import DocumentGallery from "../DocsUpload/DocumentGallery";
import { CHECK_ASSIGN_USER, IS_USER_ACCESS_PAGE } from "../../../config/constants";
import LeadRemarkHistory from "../lead/component/LeadRemarkHistory";
import Modal from "../../elements/Modal";
import { COMPUTATION_GENERATED, FIELDS_TO_APPLY, LOST_STATUS } from "../../../config/refinance/constant";
import { UPDATE_LEAD_STATUS } from "../common/api.ggl";
import { COMPUTATION_VERIFIED } from "../common/form_fields";
import { GET_CUSTOMER_TIMELINE } from "../../../services/refinance/leads.gql";
import {Tooltip} from 'react-tippy';
/**
 * Recursively removes '__typename' key from all objects and arrays
 * @param {*} data - The input data (object, array, or primitive)
 * @returns {*} - The data with all '__typename' keys removed
 */
const removeTypename = (data) => {
    if (Array.isArray(data)) {
        return data.map((item) => removeTypename(item));
    } else if (data !== null && typeof data === "object") {
        const newObj = {};
        for (const [key, value] of Object.entries(data)) {
            if (key !== "__typename") {
                newObj[key] = removeTypename(value);
            }
        }
        return newObj;
    }
    return data;
};

const MAX_DECIMAL = 14;
// const roundLargeNumber = (num) => {
//     if (typeof num !== "number") {
//         return num;
//     }

//     const strNum = num.toString();
//     const [intPart, decPart] = strNum.split(".");

//     if (strNum?.length > 16) {
//         if (decPart?.length) {
//             return strNum.substring(0, 16);
//         } else if (!decPart || strNum.length <= 16) {
//             return num;
//         }
//     }
//     const decimalPlaces = 16 - intPart.length - 1;
//     return parseFloat(num.toFixed(decimalPlaces));
// };

function roundLargeNumber(num, totalDigits = 16) {
    if (typeof num !== "number") {
        return num;
    }

    // Convert to string to manipulate easily
    let numStr = num.toString();
    
    // Find the decimal point
    const decimalIndex = numStr.indexOf('.');
    
    // Get the part before the decimal and the fractional part
    let integerPart = numStr.slice(0, decimalIndex === -1 ? undefined : decimalIndex);
    let fractionalPart = decimalIndex === -1 ? "" : numStr.slice(decimalIndex + 1);

    // If integer part is already 16 digits or more, truncate and return
    if (integerPart.length >= totalDigits) {
        return parseFloat(integerPart.slice(0, totalDigits));
    }

    // Calculate how many fractional digits we can keep
    const maxFractionalDigits = totalDigits - integerPart.length;

    // Trim trailing zeros from fractional part
    let lastSignificantIndex = fractionalPart.length - 1;
    while (lastSignificantIndex >= 0 && fractionalPart[lastSignificantIndex] === '0') {
        lastSignificantIndex--;
    }
    fractionalPart = fractionalPart.slice(0, lastSignificantIndex + 1);

    // If fractional part is longer than allowed, truncate it
    if (fractionalPart.length > maxFractionalDigits) {
        fractionalPart = fractionalPart.slice(0, maxFractionalDigits);
    }

    // Combine the parts and convert back to a number
    return parseFloat(`${integerPart}${fractionalPart ? '.' + fractionalPart : ''}`);
}

const RefinanceComputationGenerated = (props) => {
    let { lead_id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const client = useApolloClient();
    const { remarksHistory, leadDetail, user_information } = useSelector(({ lead, masterdataucrf, user }) => ({
        master_data_ucrf: masterdataucrf?.master_data_ucrf || {},
        lead,
        remarksHistory: lead.remarksHistory || [],
        leadDetail: lead?.ucrfLeadDetail || {},
        user_information: user?.user_information || {}
    }));
    const UserInfo = JSON.parse(user_information)
    const formRef = useRef();
    const [loading, setLoading] = useState(false);
    const [computationData, setComputationData] = useState({});
    const [, setBasicDetails] = useState({});
    const [computationGeneratedUserId, setComputationGeneratedUserId] = useState(0);

    const getContext = useOutletContext();
    const documentCategoryList = getContext.docList || [];
    const [ViewTimeLine, setViewTimeLine] = useState(false);
    const [showremarkform, setShowremarkform] = useState(false);
    const [, setIsSaveDisabled] = useState(true);
    const [isRemarkDisable, setIsRemarkDisabled] = useState(true);
    const [, setIsNextEnabled] = useState(false);
    const [, setIsDataFilled] = useState(false);
    const [confirmationModal, setConfirmationModal] = useState(false);
    const [comment, setComment] = useState("");
    const [openTooltip, setOpenTooltip] = useState(null);
    let accessCondition = !IS_USER_ACCESS_PAGE("refinanceComputation", "ucrf-computation-generated")?.is_edit_access;

    let accessConditionVerifiedPage = !IS_USER_ACCESS_PAGE("ucrf-computation-verified", "ucrf-computation-verified")?.is_edit_access;
    if (!accessConditionVerifiedPage) {
        accessConditionVerifiedPage = CHECK_ASSIGN_USER(leadDetail?.assigned_to);
    }
    const disableFields = useMemo(() => {
        if (props?.current_page === "computation-verified") return true;
        else if (["computation-generated"]?.includes(props?.current_page) && !["15", "42"]?.includes(leadDetail?.basic_details?.refinance_sub_status)) {
            return true;
        }
        return false;
    }, [leadDetail, props?.current_page]);
    const allowResubmit = useMemo(() => {
        if (props?.current_page === "computation-verified" && ["21"]?.includes(leadDetail?.basic_details?.refinance_sub_status) && IS_USER_ACCESS_PAGE("ucrf-computation-verified", "ucrf-computation-verified")?.is_edit_access && (computationGeneratedUserId !== UserInfo?.id || UserInfo?.role_id?.includes(1))) return false;
        return true;
    }, [leadDetail, props?.current_page, computationGeneratedUserId, UserInfo]);

    const disableComputationVerified = useMemo(() => {
        if (props?.current_page === "computation-generated" && ["15", "42"]?.includes(leadDetail?.basic_details?.refinance_sub_status)) return false;
        else if (props?.current_page === "computation-verified" && ["21"]?.includes(leadDetail?.basic_details?.refinance_sub_status) && (computationGeneratedUserId !== UserInfo?.id || UserInfo?.role_id?.includes(1))) return false;
        return true;
    }, [leadDetail, props?.current_page, computationGeneratedUserId, UserInfo]);

    useEffect(() => {
        props?.current_page === "computation-verified" && leadDetail.lead_id && getTimeLineListData(leadDetail.lead_id);
    }, [leadDetail, props?.current_page]);

    useEffect(() => {
        if (leadDetail?.computation_details) {
            const copiedData = JSON.parse(JSON.stringify(leadDetail?.computation_details));
            const initializedData = calculateValues(removeTypename(copiedData));
            setIsDataFilled(initializedData.data_filled === 1);
            setComputationData(initializedData);
        }
        checkSaveEnable(leadDetail);
        let basicDetails = { ...leadDetail.basic_details };
        setBasicDetails(basicDetails);
        dispatch(getLeadRemarkUCRF({ lead_id: leadDetail.lead_id, source: "WEB" }, client));
    }, [leadDetail]);

    const navigateToNext = () => {
        if(props?.current_page === "computation-generated") navigate(`/refinance/lead-detail/computation-verified/${lead_id}`);
        else navigate(`/refinance/lead-detail/payment-verification/${lead_id}`);
    };

    const calculateValues = (computationData) => {
        const loanAmount = parseFloat(computationData.loan_amount) || 0;
        let updatedData = { ...computationData };

        // Pass Through calculations
        if (updatedData.pass_through && +leadDetail?.basic_details?.user_onboarded === 0) {
            const payoutPercentage = parseFloat(updatedData.pass_through.payout_percentage) || 0;
            const taxPercentage = parseFloat(updatedData.pass_through.tax_percentage) || 0;

            // Direct Dealer Payout from Financier Amount Net of Tax
            // Formula: (Payout Percentage / 100 * Loan Amount) * (1 - Tax Percentage / 100)
            const payoutAmount = (payoutPercentage / 100) * loanAmount;
            updatedData.pass_through.payout_amount = roundLargeNumber(payoutAmount * (1 - taxPercentage / 100));
        }

        // Incentive Amount From Financier calculations
        if (updatedData.incentive_amount_from_financier && +leadDetail?.basic_details?.user_onboarded === 0) {
            const diPercentage = parseFloat(updatedData.incentive_amount_from_financier.di_percentage) || 0;
            const diTaxPercentage = parseFloat(updatedData.incentive_amount_from_financier.di_tax_percentage) || 0;

            // DI Amount from Financier to Carmudi Amount
            // Formula: DI Percentage / 100 * Loan Amount
            updatedData.incentive_amount_from_financier.di_amount = roundLargeNumber((diPercentage / 100) * loanAmount);

            // DI Amount from Financier to Carmudi Net of Tax
            // Formula: DI Amount * (1 - DI Tax Percentage / 100)
            let diAmount = parseFloat(updatedData.incentive_amount_from_financier.di_amount);
            if (updatedData.incentive_amount_from_financier.wht_on_gross === "Yes") {
                updatedData.incentive_amount_from_financier.di_tax_amount = roundLargeNumber(diAmount * (1 - diTaxPercentage / 100));
            } else { 
                let revenue = roundLargeNumber(diAmount / 1.12); // remove VAT 12%
                let whtAmount = roundLargeNumber(revenue * (diTaxPercentage / 100));
                let diNet = roundLargeNumber(diAmount - whtAmount);
                updatedData.incentive_amount_from_financier.di_tax_amount = diNet;
            }
            if( updatedData.incentive_amount_from_financier.is_vat_back_involved === "Yes"){
                updatedData.incentive_amount_from_financier.vat_back_percentage = parseFloat(diPercentage*12/100)
                updatedData.incentive_amount_from_financier.vat_back_amount = roundLargeNumber((updatedData.incentive_amount_from_financier.di_amount * 12 / 100)) || 0;
                
                const vatBackAmount = parseFloat(updatedData.incentive_amount_from_financier.vat_back_amount) || 0;
                const diTaxAmount = parseFloat(updatedData.incentive_amount_from_financier.di_tax_amount) || 0;
                if(updatedData.incentive_amount_from_financier.mode_of_vat_back_received==="along_with_di_payment"){
                    updatedData.incentive_amount_from_financier.final_amount_received_from_financier = roundLargeNumber(vatBackAmount + diTaxAmount);
                }else{
                    updatedData.incentive_amount_from_financier.final_amount_received_from_financier = roundLargeNumber(diTaxAmount);
                }
            }

        }
        

        // Computation Details calculations
        if (updatedData.computation_details && +leadDetail?.basic_details?.user_onboarded === 0) {
            const incentivePct = parseFloat(updatedData.computation_details.incentive_pct) || 0;
            const topupPct = parseFloat(updatedData.computation_details.topup_pct) || 0;
            const incentiveTaxPct = parseFloat(updatedData.computation_details.incentive_tax_pct) || 10; // Default to 10% if not set

            // Carmudi's Incentive %age Net of Tax
            // Formula: Carmudi Incentive %age (Gross) * 0.9
            // updatedData.computation_details.incentive_net_tax = incentivePct * 0.9;

            // Carmudi Incentive Amount
            // Formula: Carmudi Incentive %age (Gross) / 100 * Loan Value
            updatedData.computation_details.incentive_amount = roundLargeNumber((incentivePct / 100) * loanAmount);

            // Carmudi Top-up Amount
            // Formula: Carmudi Top-up % / 100 * Loan Value
            updatedData.computation_details.topup_amount = roundLargeNumber((topupPct / 100) * loanAmount);

            // Total Carmudi Incentive %age
            // Formula: Carmudi Top-up % + Carmudi Incentive %age (Gross)
            updatedData.computation_details.total_incentive_pct = incentivePct + topupPct;

            // Total Carmudi Incentive Amount
            // Formula: Carmudi Top Up Amount + Carmudi Incentive Amount
            const totalIncentiveAmount =
                parseFloat(updatedData.computation_details.incentive_amount) + parseFloat(updatedData.computation_details.topup_amount);
            updatedData.computation_details.total_incentive_amount = roundLargeNumber(totalIncentiveAmount);

            // Total Carmudi Incentive Amount Net of Tax
            // Formula: Total Carmudi Incentive Amount * (1 - Carmudi Incentive Tax %age / 100)
            updatedData.computation_details.total_incentive_amount_net_of_tax = roundLargeNumber(totalIncentiveAmount * (1 - incentiveTaxPct / 100));

            // Carmudi's Incentive %age Net of Tax
            // Formula: Total Carmudi Incentive Amount * (1 - Carmudi Incentive Tax %age)
            updatedData.computation_details.incentive_net_tax = roundLargeNumber(totalIncentiveAmount * (1 - incentiveTaxPct / 100));
        }

        return updatedData;
    };

    const submitForm = () => {
        if (formRef.current) {
            formRef.current.validateForm();
            if (formRef.current.state.isValid) {
                formRef.current.submit();
            } else {
                toast.error("Please correct the errors in the form");
            }
        }
    };

    const showModalViewTimeLine = () => {
        setViewTimeLine(true);
        setShowremarkform(true);
        document.body.classList.add("overflow-hidden");
    };

    const hideModalViewTimeLine = () => {
        setViewTimeLine(false);
        document.body.classList.remove("overflow-hidden");
    };

    const handleChange = (event, parentField, childField, fieldType) => {
        let tempComputationDetails = JSON.parse(JSON.stringify(computationData));

        if (!tempComputationDetails[parentField]) {
            tempComputationDetails[parentField] = {};
        }
        let newValue;
        if (fieldType === "number-format") {
            newValue = event.value;
        } else if (fieldType === "text") {
            newValue = getMax16DigitValidation("percent", event.target.value);
        } else if (["radio", "input"].includes(fieldType)) {
            newValue = event.target.value;
        }

        if (newValue) {
            if (childField === "dealer_incentive_amount") {
                tempComputationDetails["pass_through"]["payout_percentage"] = "";
                tempComputationDetails["pass_through"]["tax_percentage"] = "";
                tempComputationDetails["pass_through"]["payout_amount"] = "";
            }
            if (childField === "is_vat_back_involved") {
                tempComputationDetails["incentive_amount_from_financier"]["vat_back_percentage"] = "";
                tempComputationDetails["incentive_amount_from_financier"]["vat_back_amount"] = "";
                tempComputationDetails["incentive_amount_from_financier"]["final_amount_received_from_financier"] = "";
                 if (newValue === "No") {
                    tempComputationDetails["incentive_amount_from_financier"]["mode_of_vat_back_received"] = "";
                }
                else if (newValue === "Yes") {
                    tempComputationDetails["incentive_amount_from_financier"]["mode_of_vat_back_received"] = "along_with_di_payment";
                }
            }
            tempComputationDetails[parentField][childField] = newValue;
            const updatedData = calculateValues(tempComputationDetails);
            setComputationData(updatedData);
        }
    };

    const getMax16DigitValidation = (type, value) => {
        if (type === "percent") {
            let validated = value > 100 ? false : true;
            let valueToUpdate = value;
            if (validated) {
                if (valueToUpdate === "" || (valueToUpdate >= 0 && valueToUpdate <= 100 && valueToUpdate.length <= 16)) {
                    return valueToUpdate;
                }
            }
        } else {
            let validated = value?.replace(".", "").length > 16 ? false : true;
            let valueToUpdate = value;
            if (validated) {
                return valueToUpdate;
            } else {
                return valueToUpdate.substring(0, 16);
            }
        }
    };

    const handleSave = () => {
        setLoading(true);
        const lead_id = leadDetail.lead_id || "";

        const refinanceInput = {
            lead_id: lead_id.toString(),
            financier_id: computationData.financier_id.toString(),
            loan_amount: computationData.loan_amount,
            pass_through: {
                dealer_incentive_amount: computationData.pass_through.dealer_incentive_amount.toString(),
            },
            incentive_amount_from_financier: {
                di_percentage: computationData.incentive_amount_from_financier.di_percentage.toString(),
                di_amount: computationData.incentive_amount_from_financier.di_amount.toString(),
                di_tax_percentage: computationData.incentive_amount_from_financier.di_tax_percentage.toString(),
                di_tax_amount: computationData.incentive_amount_from_financier.di_tax_amount.toString(),
                wht_on_gross: computationData.incentive_amount_from_financier.wht_on_gross.toString(),
                is_vat_back_involved: computationData.incentive_amount_from_financier.is_vat_back_involved.toString(),
                vat_back_percentage: computationData.incentive_amount_from_financier.vat_back_percentage.toString(),
                vat_back_amount: computationData.incentive_amount_from_financier.vat_back_amount.toString(),
                final_amount_received_from_financier: computationData.incentive_amount_from_financier.final_amount_received_from_financier.toString(),
                mode_of_vat_back_received: computationData.incentive_amount_from_financier.mode_of_vat_back_received.toString(),
            },
        };

        if (computationData?.pass_through?.dealer_incentive_amount === "no") {
            refinanceInput.computation_details = {
                incentive_pct: computationData.computation_details.incentive_pct.toString(),
                incentive_amount: computationData.computation_details.incentive_amount.toString(),
                topup_pct: computationData.computation_details.topup_pct.toString(),
                topup_amount: computationData.computation_details.topup_amount.toString(),
                total_incentive_pct: computationData.computation_details.total_incentive_pct.toString(),
                total_incentive_amount: computationData.computation_details.total_incentive_amount.toString(),
                incentive_tax_pct: computationData.computation_details.incentive_tax_pct.toString(),
                incentive_net_tax: computationData.computation_details.incentive_net_tax.toString(),
            };
        }

        if (refinanceInput.pass_through.dealer_incentive_amount === "yes") {
            refinanceInput.pass_through.payout_percentage = computationData.pass_through.payout_percentage.toString();
            refinanceInput.pass_through.tax_percentage = computationData.pass_through.tax_percentage.toString();
            refinanceInput.pass_through.payout_amount = computationData.pass_through.payout_amount.toString();
        }

        const variables = {
            refinanceInput: refinanceInput,
        };

        executeGraphQLMutation(SAVE_REFINANCE_CALCULATION, variables, client)
            .then((response) => {
                if (response?.data) {
                    toast.success(response.data.saveRefinanceCalculation.message);
                    dispatch(getUCRFLeadDetail(lead_id, client));
                    dispatch(getUCRFFormFillStatus({ lead_id }, client));
                    navigateToNext();
                }
            })
            .catch((error) => {
                toast.error(error.message);
            })
            .finally(() => {
                setLoading(false);
            });
    };
    const sectionInfo = {
        "computation-generated": { section: "Computation Generated", sub_section: "Dealer Incentive" },
        "computation-verified": { section: "Computation Verified", sub_section: "Dealer Incentive" }
    };

    const checkSaveEnable = (leadDetail) => {
        let markAsFreezed = 0;
        let leadLost = leadDetail?.basic_details?.refinance_status ? leadDetail?.basic_details?.refinance_status === LOST_STATUS.toString() : false;
        let user_page_access = (props?.current_page === "computation-verified") ? IS_USER_ACCESS_PAGE("ucrf-computation-verified", "ucrf-computation-verified")?.is_edit_access : IS_USER_ACCESS_PAGE("refinanceComputation", "ucrf-computation-generated")?.is_edit_access;
        let user_edit_access = CHECK_ASSIGN_USER(leadDetail.assigned_to);
        let nextEnable =
            leadDetail?.customer_timeline_status_ids?.length && leadDetail.customer_timeline_status_ids.findIndex((e) => +e === +COMPUTATION_GENERATED) > -1
                ? true
                : false;
        if (nextEnable) {
            setIsNextEnabled(true);
            setIsSaveDisabled(true)
        } else if (!user_edit_access && user_page_access && !leadLost && !markAsFreezed && !nextEnable) {
            setIsSaveDisabled(false);
            setIsNextEnabled(false)
        } else {
            setIsSaveDisabled(true)
            setIsNextEnabled(false)
        }
        if (!user_edit_access && user_page_access) {
            setIsRemarkDisabled(false);
        }
    };

    const showConfirmation = () => {
        setConfirmationModal(true);
        document.body.classList.add("overflow-hidden");
    }
  
    const hideConfirmation = () => {
        setConfirmationModal(false);
        document.body.classList.remove("overflow-hidden");
    }
    const updateComputationVerified = (action_type) => {
        let variables = {
            updateleadstatus: { page_type: action_type, user_id: UserInfo?.id, user_name: UserInfo?.name, lead_id: leadDetail?.lead_id || "", remarks: comment }
        };
        setLoading(true);
        executeGraphQLMutation(UPDATE_LEAD_STATUS, variables, client).then((response) => {
            toast.success(response?.data?.updateLeadStatus?.message || "Success!");
            dispatch(getUCRFLeadDetail(leadDetail?.lead_id || "", client));
            dispatch(getUCRFFormFillStatus({ lead_id: leadDetail?.lead_id || "" }, client));
            action_type === 'computation_resubmit' && navigate(`/refinance/lead-detail/computation-generated/${lead_id}`);
            action_type === 'computation_verified' && navigate(`/refinance/lead-detail/payment-verification/${lead_id}`);
            setComment("");
            hideConfirmation();
        }).catch(err => {
            hideConfirmation();
            toast.error(err.toString().replace('ApolloError:', ''));
        }).finally(()=> setLoading(false));
    };

    const getTimeLineListData = async (lead_id) => {
        executeGraphQLQuery(GET_CUSTOMER_TIMELINE(lead_id), client).then((result) => {
            if (result?.data?.getCustomerTimeline) {
                const lead_history = result?.data?.getCustomerTimeline;
                if (lead_history?.customer_timeline?.length) {
                    const computationGeneratedHistory = lead_history.customer_timeline?.find(history => history?.refinance_sub_status_id === COMPUTATION_GENERATED);
                    if (computationGeneratedHistory) {
                        setComputationGeneratedUserId(computationGeneratedHistory?.created_by_id);
                    } else {
                        setComputationGeneratedUserId(0);
                    }
                }
            }
        })
            .catch((error) => {
                console.error('Query error:', error);
            });
    };

    return (
        <>
            <div className="image-form-outer">
                {loading ? <Loader /> : ""}
                <div className="image-tab-panel">
                    <DocumentGallery documentCategoryList={documentCategoryList} />
                </div>
                <div className="form-tab-right-panel">
                    <div className="lead-detail-from-outer">
                        <div className={" switch-toggle"}>
                            <div className="lead-form-heading">
                                <span className="main-heading">{sectionInfo?.[props?.current_page]?.section || "Computation Generated"}</span>
                                <h2>Dealer Incentive</h2>
                                {(props.current_page === 'computation-verified' && ["21"]?.includes(leadDetail?.basic_details?.refinance_sub_status)) ?
                                    <div className="">
                                        <button type="submit" class="resubmit-btn re-submit-btn" onClick={showConfirmation} disabled={accessConditionVerifiedPage || allowResubmit}>
                                            Resubmit <img src={""} alt={""} className="resubmit-icn" /> 
                                        </button>
                                    </div> :( <></> )
                                }
                            </div>
                            <Formsy className="lead-form-filed soft-approval-filled-outer" autoComplete="off" ref={formRef} onSubmit={handleSave}>
                                <Accordion allowZeroExpanded>
                                    <div className="">
                                        <AccordionItem className="acc-item-financer">
                                            <AccordionItemHeading className="acc-heading-financer">
                                                <AccordionItemButton>
                                                    <div className="f-16">
                                                        <h3 title={"Pass Through Details"}>Pass Through Details</h3>
                                                    </div>
                                                </AccordionItemButton>
                                            </AccordionItemHeading>
                                            <AccordionItemPanel className="acc-panel-finaner">
                                                <div className="soft-approvel-sec">
                                                    <div className="row">
                                                        {
                                                            COMPUTATION_VERIFIED?.pass_through?.map((field, index) => {
                                                                return field.type === 'radio' ? (
                                                                    <fieldset className="form-filed col-md-12 radio-btn radio-type-txt">
                                                                        <label className="form-label">{field.label}</label>
                                                                        {field.options.map((option) => (
                                                                            <div className="custom-control custom-checkbox" key={option.value}>
                                                                                <input
                                                                                    id={option.value}
                                                                                    type={field?.type}
                                                                                    className="custom-control-input"
                                                                                    name={option.name}
                                                                                    value={option?.value || ""}
                                                                                    defaultChecked={option?.value === computationData?.pass_through?.[option?.name] ? true : false}
                                                                                    checked={option?.value === computationData?.pass_through?.[option?.name] ? true : false}
                                                                                    onChange={(e) => handleChange(e, "pass_through", option?.name, field?.type)}
                                                                                    disabled={accessCondition || disableFields}
                                                                                    required={true}
                                                                                    aria-label="handle change radio"
                                                                                />
                                                                                <label htmlFor={option.id} className="custom-control-label">{option.label}</label>
                                                                            </div>
                                                                        ))}
                                                                    </fieldset>) :
                                                                    ["text", "number-format"]?.includes(field?.type) ? (
                                                                        <fieldset class="form-filed col-md-12 ">
                                                                            <FormsyInputField
                                                                                id={field?.id}
                                                                                name={field?.name}
                                                                                type={field?.type}
                                                                                value={computationData?.pass_through?.[field?.name] || ""}
                                                                                placeholder=" "
                                                                                label={field?.label || ""}
                                                                                onChange={(e) => {
                                                                                    handleChange(e, "pass_through", field?.name, field?.type);
                                                                                }}
                                                                                rule={field?.validations}
                                                                                validationError={field?.validationError || ""}
                                                                                readOnly={computationData?.pass_through?.dealer_incentive_amount === "no"}
                                                                                required={computationData?.pass_through?.dealer_incentive_amount === "yes"}
                                                                                showAsterisk={true}
                                                                                disabled={accessCondition || disableFields}
                                                                                {...(field?.type === "number-format") ? {
                                                                                    thousandsGroupStyle: "thousand",
                                                                                    thousandSeparator: ',',
                                                                                    decimalSeparator: '.'
                                                                                } : {}}
                                                                                {...(FIELDS_TO_APPLY.COMPUTATION_PAGE?.includes(field?.name)) ? {
                                                                                    decimalScale: MAX_DECIMAL
                                                                                } : {}}
                                                                            />
                                                                        </fieldset>) :
                                                                        <></>;
                                                            })
                                                        }
                                                    </div>
                                                </div>
                                            </AccordionItemPanel>
                                        </AccordionItem>
                                    </div>
                                </Accordion>

                                <Accordion allowZeroExpanded>
                                    <div className="">
                                        <AccordionItem className="acc-item-financer">
                                            <AccordionItemHeading className="acc-heading-financer">
                                                <AccordionItemButton>
                                                    <div className="f-16">
                                                        <h3 title={"Incentive Amount From Financier"}>Incentive Amount From Financier</h3>
                                                    </div>
                                                </AccordionItemButton>
                                            </AccordionItemHeading>
                                            <AccordionItemPanel className="acc-panel-finaner">
                                                <div className="soft-approvel-sec">
                                                    <div className="row">
                                                        {
                                                            COMPUTATION_VERIFIED?.incentive_amount_from_financier?.map((field, index) => {
                                                                const vatInvolved = computationData?.incentive_amount_from_financier?.is_vat_back_involved === "Yes";
                                                                const isVatField = ["vat_back_percentage", "vat_back_amount", "final_amount_received_from_financier","mode_of_vat_back_received"].includes(field.name);

                                                                if (isVatField && !vatInvolved) return null;
                                                                return field.type === 'radio' ? (
                                                                    <>
                                                                    {['is_vat_back_involved'].includes(field.name) && <div className="col-md-12 full-width-line-radio"></div>}
                                                                    <fieldset className="form-filed col-md-12 radio-btn radio-type-txt">
                                                                        <label className="form-label label-with-tooltip">{field.label}
                                                                             {["wht_on_gross"].includes(field.name) && (
                                                                                <>
                                                                                    <i onClick={() => setOpenTooltip((prev) => prev === field.name ? null : field.name )} className="ic-info-icon1"></i>
                                                                                    <Tooltip
                                                                                        html={
                                                                                            <div className="controlled-example tooltip-main">
                                                                                            <span className="controlled-example_close-button" onClick={() => setOpenTooltip(null)}>
                                                                                                <i className="ic-clearclose"></i>
                                                                                            </span>
                                                                                            <p>If No, WHT will be calculated on Net of VAT.</p>
                                                                                            </div>
                                                                                        }
                                                                                        open={openTooltip === field.name}
                                                                                        tagName="span"
                                                                                        position="bottom"
                                                                                        trigger="manual"
                                                                                        interactive={true}
                                                                                        animateFill={false}
                                                                                        arrow={true}
                                                                                        arrowSize="small"
                                                                                        className="tooltip-outer"
                                                                                    />
                                                                                </>
                                                                            )}
                                                                        </label>
                                                                        {field.options.map((option) => (
                                                                            <div className="custom-control custom-checkbox" key={option.value}>
                                                                                <input
                                                                                    id={`${field.name}_${option.value}`}
                                                                                    type="radio"
                                                                                    className="custom-control-input"
                                                                                    name={field.name}
                                                                                    value={option.value}
                                                                                     checked={
                                                                                        computationData?.incentive_amount_from_financier?.[field.name]
                                                                                        ? computationData.incentive_amount_from_financier[field.name] === option.value
                                                                                        : option.value === (field.name === "mode_of_vat_back_received" ? "along_with_di_payment" : "")
                                                                                    }
                                                                                    onChange={(e) => handleChange(e, "incentive_amount_from_financier", field.name, field.type)}
                                                                                    disabled={accessCondition || disableFields}
                                                                                    required
                                                                                    aria-label={`handle change ${field.name}`}
                                                                                />
                                                                                <label htmlFor={`${field.name}_${option.value}`} className="custom-control-label">
                                                                                    {option.label}
                                                                                </label>
                                                                            </div>
                                                                        ))}
                                                                    </fieldset></>) : ["text", "number-format"]?.includes(field?.type) ? (
                                                                    <fieldset class="form-filed col-md-12 ">
                                                                        <FormsyInputField
                                                                            id={field?.id}
                                                                            name={field?.name}
                                                                            type={field?.type}
                                                                            value={computationData?.incentive_amount_from_financier?.[field?.name] || ""}
                                                                            placeholder=" "
                                                                            label={
                                                                                field?.name === "final_amount_received_from_financier" &&
                                                                                computationData?.incentive_amount_from_financier?.mode_of_vat_back_received ===
                                                                                "as_additional_revenue"
                                                                                ? "Final Amount Received from Financier (DI Net)"
                                                                                : field?.label || ""
                                                                            }
                                                                            onChange={(e) => {
                                                                                handleChange(e, "incentive_amount_from_financier", field?.name, field?.type);
                                                                            }}
                                                                            rule={field?.validations}
                                                                            validationError={field?.validationError || ""}
                                                                            readOnly={field.readOnly}
                                                                            required={field.required}
                                                                            showAsterisk={true}
                                                                            disabled={accessCondition || disableFields}
                                                                            {...(field?.type === "number-format") ? {
                                                                                thousandsGroupStyle: "thousand",
                                                                                thousandSeparator: ',',
                                                                                decimalSeparator: '.',
                                                                            } : {}}
                                                                            {...(FIELDS_TO_APPLY.COMPUTATION_PAGE?.includes(field?.name)) ? {
                                                                                decimalScale: MAX_DECIMAL
                                                                            } : {}}
                                                                        />
                                                                    </fieldset>) :
                                                                    <></>;
                                                            })
                                                        }
                                                    </div>
                                                </div>
                                            </AccordionItemPanel>
                                        </AccordionItem>
                                    </div>
                                </Accordion>
                                {computationData?.pass_through?.dealer_incentive_amount === "no" ? (
                                    <Accordion allowZeroExpanded>
                                        <div className="">
                                            <AccordionItem className="acc-item-financer">
                                                <AccordionItemHeading className="acc-heading-financer">
                                                    <AccordionItemButton>
                                                        <div className="f-16">
                                                            <h3 title={"Computation Details"}>Computation Details</h3>
                                                        </div>
                                                    </AccordionItemButton>
                                                </AccordionItemHeading>
                                                <AccordionItemPanel className="acc-panel-finaner">
                                                    <div className="soft-approvel-sec">
                                                        <div className="row">
                                                            {
                                                                COMPUTATION_VERIFIED?.computation_details?.map((field) => {
                                                                    return ["text", "number-format"]?.includes(field?.type) ? (
                                                                        <fieldset class="form-filed col-md-6">
                                                                            {console.log("computationData?.computation_details?.[field?.name]>>>>>>", field?.name, computationData?.computation_details?.[field?.name])}
                                                                            <FormsyInputField
                                                                                id={field?.id}
                                                                                name={field?.name}
                                                                                type={field?.type}
                                                                                value={computationData?.computation_details?.[field?.name] ? computationData?.computation_details?.[field?.name] : (["number-format"]?.includes(field?.type) ? 0 : "")}
                                                                                placeholder=" "
                                                                                label={field?.label || ""}
                                                                                onChange={(e) => {
                                                                                    handleChange(e, "computation_details", field?.name, field?.type);
                                                                                }}
                                                                                rule={field?.validations}
                                                                                validationError={field?.validationError || ""}
                                                                                readOnly={field?.readOnly}
                                                                                required={field?.required}
                                                                                showAsterisk={field?.showAsterisk}
                                                                                disabled={accessCondition || disableFields}
                                                                                {...(field?.type === "number-format") ? {
                                                                                    thousandsGroupStyle: "thousand",
                                                                                    thousandSeparator: ',',
                                                                                    decimalSeparator: '.'
                                                                                } : {}}
                                                                                {...(FIELDS_TO_APPLY.COMPUTATION_PAGE?.includes(field?.name)) ? {
                                                                                    decimalScale: MAX_DECIMAL
                                                                                } : {}}
                                                                            />
                                                                        </fieldset>) :
                                                                        <></>;
                                                                })
                                                            }
                                                        </div>
                                                    </div>
                                                </AccordionItemPanel>
                                            </AccordionItem>
                                        </div>
                                    </Accordion>
                                ) : null}
                            </Formsy>
                        </div>
                        <div className="btn-save-remarks">
                            {
                                props.current_page === 'computation-generated' ?
                                    <button aria-label="save next" type="submit" onClick={() => submitForm()} disabled={accessCondition || disableComputationVerified} className="btn-primary">
                                        Save & Next
                                    </button> :
                                    props.current_page === 'computation-verified' ?
                                        <button aria-label="save next" type="submit" onClick={() => updateComputationVerified("computation_verified")} disabled={accessConditionVerifiedPage || disableComputationVerified} className="btn-primary">
                                            Save & Next
                                        </button> :
                                        <span className="span-disabled">Save</span>
                            }
                            <button aria-label="remarks history" type="button" className="btn-line" onClick={showModalViewTimeLine}>
                                Remarks
                                <span className="m-xs-l">({remarksHistory && (remarksHistory.length || 0)})</span>
                            </button>
                        </div>
                    </div>
                </div>
                <div className="view-timeline-popup">
                    <Modal show={ViewTimeLine} handleClose={hideModalViewTimeLine}>
                        <div className="modal-header">
                            <h2>Remark History</h2>
                        </div>
                        <LeadRemarkHistory
                            showremarkform={showremarkform}
                            markAsFreezed={getContext.markAsFreezedNewFlow}
                            sectionInfo={sectionInfo}
                            isRemarkDisable={isRemarkDisable}
                        />
                    </Modal>
                </div>

                <div className="view-timeline-popup">
                    <Modal show={confirmationModal} handleClose={hideConfirmation} >
                        <div className="modal-header">
                            <h2 style={{"padding-bottom":"0px"}}>Additional Remarks for re-submisison</h2>
                            <div style={{"padding-bottom":"20px"}}>For holding the <span  style={{"font-weight":"600"}}>Financier Computation Details</span></div>
                        </div>
                        <div className="modal-body" >
                        <div className="custom-control custom-checkbox">
                        <div class="material">
                                <textarea
                                    name="remarks"
                                    id="remarks"
                                    placeholder="Comments/Reason"
                                    class="form-input"
                                    rows="3"
                                    onChange={(e) => setComment(e.target.value)}
                                    value={comment}
                                >
                                </textarea>
                            </div>
                            <button class="btn-primary m-md-t" onClick={() => updateComputationVerified("computation_resubmit")} disabled={!comment.length}>Submit</button>
                            </div>
                        </div>
                    </Modal>
                </div>
            </div>
        </>
    );
};

export default RefinanceComputationGenerated;
